<template>
    <el-dialog
        class="upload-costreduction-dialog"
        :title="tempTitle"
        :visible.sync="visible"
        width="960px"
        :before-close="handleClose">
        <div class="warn-tip">招标结果审批必须上传下列4个附件</div>
        <el-table :data="tableData" stripe border v-loading="loading">
            <el-table-column prop="fileName" label="附件名称" width="160">
                <template v-slot="scope">
                    <span class="required-color">*</span>
                    {{ scope.row.fileName }}
                </template>
            </el-table-column>
            <el-table-column prop="uploadFileName" label="上传附件名称">
                <template v-slot="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.uploadFileFullName"
                        placement="top-start">
                        <el-button type="text" @click="onPreview(scope.row)">{{ scope.row.uploadFileName }}</el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="uploadDate" label="上传时间" width="140"></el-table-column>
            <el-table-column label="操作" width="300">
                <template v-slot="scope">
                    <div class="upload-costreduction-content" v-show="!scope.row.btns.includes('newTempDownload')">
                        <Upload
                            :ref="'upload'+scope.$index"
                            uploadDisplayType="text"
                            sizeLimit="10"
                            text="上传"
                            icon="el-icon-upload2"
                            :flag="scope.row.uploadName"
                            @uploadSuccess="handleUploadSuccess"></Upload>
                    </div>
                    <div class="before-upload" v-if="scope.row.btns.includes('newTempDownload')">
                        <el-button
                            @click="showUploadTips(scope.$index, scope.row.tip)"
                            type="text"
                            size="small">
                            上传
                        </el-button>
                    </div>
                    <el-button
                        @click="onClearFile(scope.row)"
                        v-if="scope.row.btns.includes('delBtn') && scope.row.state"
                        type="text"
                        size="small">
                        删除
                    </el-button>
                    <el-button
                        @click="onTemplateDownload(scope.row.fileAttribute)"
                        v-if="scope.row.btns.includes('templateDownload')"
                        type="text"
                        size="small">
                        模板下载
                    </el-button>
                    <el-button
                        style="color: red;"
                        @click="onTemplateDownload(scope.row.fileAttribute)"
                        v-if="scope.row.btns.includes('newTempDownload')"
                        type="text"
                        size="small">
                        最新模板下载
                    </el-button>
                    <el-button
                        @click="onTemplateDownload(scope.row.transportDownload)"
                        v-if="scope.row.btns.includes('transportDownload')"
                        type="text"
                        size="small">
                        运输模板下载
                    </el-button>
                    <el-button
                        @click="onTemplateDownload(scope.row.loadingUnloadingDownload)"
                        v-if="scope.row.btns.includes('loadingUnloadingDownload')"
                        type="text"
                        size="small">
                        装卸模板下载
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <Preview v-if="attachmentShow" :attachmentShow.sync="attachmentShow" :rowData="previewData" />

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button
                type="primary"
                :loading="saveLoading"
                :disabled="disabledFlow.includes(currentFlow)"
                @click="handleSave">
                保 存
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import Upload from '../../../../lsrm/components/upload/Index.vue'
import Preview from '../../../../lsrm/components/viewAttachment.vue'
import {
    bidResultTemplateDownloadTpl,
    uplaodQueryByBidNo,
    bidResultAttachmentSave,
    queryAuditStatus,
} from '../../../api/tenderResult'
const FILETEMPLATECODE = 30;//文件模板

export default {
    name: 'UploadDialog',
    components: { Upload, Preview },
    props: {
        tempTitle: {
            type: String,
            default() {
                return ''
            },
        },
        bidNo: {
            type: String,
            default() {
                return ''
            },
        },
        uploadPath: {
            type: String,
            default() {
                return ''
            },
        },
    },
    data() {
        return {
            visible: false,
            loading: false,
            saveLoading: false,
            attachmentShow: false,
            previewData: {},
            tableData: [],
            fileList: [],
            currentFlow: '',
            disabledFlow: ['10', '20', '30', '90', '100'], //数据字典 SRM_AUDIT_STATUS：'提交',通过、驳回、处理中、其它
        }
    },
    mounted() {},
    computed: {},
    methods: {
        showUploadTips(idx, tip){
            this.$confirm(tip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs['upload'+idx].$children[0].$children[0].handleClick()
            })
        },
        init() {
            this.tableData = [
                {
                    fileName: '招标现场签到表',
                    uploadName: 'uploadSignIn',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '301',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                    btns: ['uploadBtn', 'delBtn', 'templateDownload'],
                },
                {
                    fileName: '招标现场记录表',
                    uploadName: 'uploadRecords',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '302',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                    btns: ['uploadBtn', 'delBtn', 'newTempDownload'],
                    tip: '是否已使用现场记录表最新模板，且填写完整（不能简单打勾，按实际情况填写完整）并招标小组所有成员签字确认。否则会被登记未按招采管理办法要求操作且考核信用积分',
                },
                {
                    fileName: '测算表',
                    uploadName: 'uploadCalculation',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '303',
                    transportDownload: '303',
                    loadingUnloadingDownload: '304',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                    btns: ['uploadBtn', 'delBtn', 'transportDownload', 'loadingUnloadingDownload'],
                },
                {
                    fileName: '招标/议价总结报告',
                    uploadName: 'uploadBargaining',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '305',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                    btns: ['uploadBtn', 'delBtn', 'newTempDownload'],
                    tip: '需核实中标供应商、中标规模填写无误，且招标/议价小组所有成员签字确认。否则会被登记未按招采管理办法要求操作且考核信用积分',
                },
            ]
            this.getData()
            this.getQueryAuditStatus()
        },
        getData() {
            let params = {
                bidNo: this.bidNo,
            }
            this.loading = true
            uplaodQueryByBidNo(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { bidOnSiteRecodeAttrInfo, bidOnSiteSignInAttrInfo, measureAttrInfo, summaryAttrInfo } =
                            res.data
                        for (const item of this.tableData) {
                            if (item.uploadName === 'uploadSignIn' && bidOnSiteSignInAttrInfo) {
                                //招标现场签到表
                                let fullName = bidOnSiteSignInAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (bidOnSiteSignInAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = bidOnSiteSignInAttrInfo.downLoadUrl
                                item.fileSuffix = bidOnSiteSignInAttrInfo.fileSuffix
                                item.uploadDate = bidOnSiteSignInAttrInfo.updateTime
                            } else if (item.uploadName === 'uploadRecords' && bidOnSiteRecodeAttrInfo) {
                                //招标现场记录表
                                let fullName = bidOnSiteRecodeAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (bidOnSiteRecodeAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = bidOnSiteRecodeAttrInfo.downLoadUrl
                                item.fileSuffix = bidOnSiteRecodeAttrInfo.fileSuffix
                                item.uploadDate = bidOnSiteRecodeAttrInfo.updateTime
                            } else if (item.uploadName === 'uploadCalculation' && measureAttrInfo) {
                                //测算表
                                let fullName = measureAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (measureAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = measureAttrInfo.downLoadUrl
                                item.fileSuffix = measureAttrInfo.fileSuffix
                                item.uploadDate = measureAttrInfo.updateTime
                            } else if (item.uploadName === 'uploadBargaining' && summaryAttrInfo) {
                                //招标/议价总结报告
                                let fullName = summaryAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (summaryAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = summaryAttrInfo.downLoadUrl
                                item.fileSuffix = summaryAttrInfo.fileSuffix
                                item.uploadDate = summaryAttrInfo.updateTime
                            }
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        getQueryAuditStatus() {
            let params = {
                bidNo: this.bidNo,
            }
            queryAuditStatus(params).then(res => {
                if (res && +res.code === 0) {
                    const { auditStatus } = res.data
                    this.currentFlow = auditStatus
                }
            })
        },
        onClearFile(row) {
            row.state = false
            row.uploadFileName = ''
            row.uploadFileFullName = ''
            row.uploadId = ''
        },
        setFileName(fullName) {
            let newName = fullName
            let nameList = fullName.split('.')
            if (nameList[0] && nameList[0].length > 20) {
                let beforName = nameList[0].substring(0, 20)
                newName = `${beforName}....${nameList[nameList.length - 1]}`
            }
            return newName
        },
        handleUploadSuccess(data) {
            let uploadName = data.flag
            let localFileName = data.data.data.localFileName
            let downUrl = data.data.data.downUrl
            let fileSuffix = data.data.data.type
            let newName = this.setFileName(localFileName)
            for (const item of this.tableData) {
                if (item.uploadName === uploadName) {
                    item.uploadFileName = newName
                    item.uploadId = data.data.data.id
                    item.state = true
                    item.uploadFileFullName = localFileName
                    item.downLoadUrl = downUrl
                    item.fileSuffix = fileSuffix
                    break;
                }
            }
        },
        handleClose() {
            this.fileList = []
            this.visible = false
        },
        handleVisible(flag, data) {
            this.visible = !!flag
            this.init()
        },
        onPreview(row) {
            this.attachmentShow = true
            this.previewData = { downUrl: row.downLoadUrl }
        },
        handleSave() {
            let params = {
                bidNo: this.bidNo,
                moduleType: FILETEMPLATECODE,
            }

            for (const item of this.tableData) {
                if (!item.state) {
                    this.$message.warning('招标结果审批必须上传下列4个附件')
                    return
                }
                if (item.uploadName === 'uploadSignIn') {
                    //招标现场签到表
                    params.bidOnSiteSignInAttrInfo = {
                        fileId: item.uploadId,
                        moduleType: FILETEMPLATECODE,
                        fileName: item.uploadFileFullName,
                        fileAttribute: item.fileAttribute,
                        fileSuffix: item.fileSuffix,
                        downLoadUrl: item.downLoadUrl,
                    }
                } else if (item.uploadName === 'uploadRecords') {
                    //招标现场记录表
                    params.bidOnSiteRecodeAttrInfo = {
                        fileId: item.uploadId,
                        moduleType: FILETEMPLATECODE,
                        fileName: item.uploadFileFullName,
                        fileAttribute: item.fileAttribute,
                        fileSuffix: item.fileSuffix,
                        downLoadUrl: item.downLoadUrl,
                    }
                } else if (item.uploadName === 'uploadCalculation') {
                    //测算表
                    params.measureAttrInfo = {
                        fileId: item.uploadId,
                        moduleType: FILETEMPLATECODE,
                        fileName: item.uploadFileFullName,
                        fileAttribute: item.fileAttribute,
                        fileSuffix: item.fileSuffix,
                        downLoadUrl: item.downLoadUrl,
                    }
                } else if (item.uploadName === 'uploadBargaining') {
                    //招标/议价总结报告
                    params.summaryAttrInfo = {
                        fileId: item.uploadId,
                        moduleType: FILETEMPLATECODE,
                        fileName: item.uploadFileFullName,
                        fileAttribute: item.fileAttribute,
                        fileSuffix: item.fileSuffix,
                        downLoadUrl: item.downLoadUrl,
                    }
                }
            }

            bidResultAttachmentSave(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('保存成功')
                        this.visible = false
                    }
                })
                .finally(() => {
                    this.saveLoading = false
                })
        },
        //下载模板
        onTemplateDownload(fileAttribute) {
            if (!fileAttribute) {
                this.$message.warning('文件类型编码不能为空')
                return
            }
            bidResultTemplateDownloadTpl({ fileAttribute })
                .then(res => {
                    if (res && +res.code === 0) {
                        const { localFileName, downUrl } = res.data
                        const a = document.createElement('a')
                        a.style.display = 'none'
                        a.download = `${localFileName}.xlsx`
                        a.href = downUrl
                        a.click()
                        document.body.removeChild(a)
                    }
                })
                .catch(() => {})
        },
    },
}
</script>
<style lang="less">
.upload-costreduction-content {
    .register-upload {
        position: relative;
        bottom: -5px;
        font-size: 14px;
        color: #00bcbf;
    }
}

.before-upload{
    padding: 0 10px;

    .el-button{
        border: none;
    }
}

.upload-costreduction-dialog {
    .required-color {
        color: #f56c6c;
    }

    .warn-tip {
        margin-bottom: 10px;
        // color: #e6a23c;
        color: #f56c6c;
    }

    .upload-demo {
        position: relative;

        .el-upload {
            // margin-top: 1px;
            padding: 1px 10px 0;
            margin-bottom: 0;
        }

        .el-upload__tip {
            position: absolute;
            top: 0;
            left: 100px;
            font-size: 12px;
        }
    }

    .template-tip {
        padding-left: 43px;
    }

    .template-tip,
    .el-button {
        font-size: 14px;
    }
}
</style>
